import type { ContextFileDef } from '@/lib/artifactCatalog'

interface ContextFileCardProps {
  file: ContextFileDef
}

/**
 * "Coming soon" tile for the AI Context Files row. The backend
 * `/context/generate` endpoint is a P1 flag — until it ships, the cards
 * render inert. `aria-disabled` + the absence of a click handler keep
 * keyboard users from getting a misleading focus on a non-action.
 */
export function ContextFileCard({ file }: ContextFileCardProps) {
  return (
    <article
      data-testid={`context-file-${file.filename}`}
      aria-disabled
      className="rounded-lg border border-border-default bg-bg-primary p-5 opacity-60 cursor-default"
    >
      <div className="flex items-center justify-center w-10 h-10 rounded-md bg-bg-elevated font-mono text-xs font-medium text-accent mb-4">
        {file.iconTag}
      </div>
      <h3 className="text-sm font-display font-semibold text-text-primary mb-1">
        {file.filename}{' '}
        <span className="ml-2 text-[10px] font-mono uppercase text-text-tertiary tracking-wider">
          Soon
        </span>
      </h3>
      <p className="text-xs text-text-secondary leading-relaxed mb-3">
        {file.description}
      </p>
      <span className="text-[11px] font-mono text-text-tertiary">
        Not yet available
      </span>
    </article>
  )
}
